import React, { useCallback, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import TermsPanel from "./TermsPanel";
import {
  acceptLegalDocument,
  fetchMyLegalAcceptanceStatus,
  TERMS_DOCUMENT_ID,
} from "../../lib/legalGraphql";
import { getCurrentUser } from "../../common/auth";
import "./TermsPanel.css";

const EXCLUDED_PREFIXES = ["/login", "/onboarding/cuenta"];

export default function LegalAcceptanceGate({ children }) {
  const location = useLocation();
  const [status, setStatus] = useState(null);
  const [loading, setLoading] = useState(true);
  const [scrollComplete, setScrollComplete] = useState(false);
  const [checked, setChecked] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState("");

  const isExcluded = EXCLUDED_PREFIXES.some((p) =>
    location.pathname.toLowerCase().startsWith(p.toLowerCase())
  );

  const refresh = useCallback(async () => {
    const user = getCurrentUser();
    if (!user || isExcluded) {
      setStatus(null);
      setLoading(false);
      return;
    }
    setLoading(true);
    try {
      const next = await fetchMyLegalAcceptanceStatus(TERMS_DOCUMENT_ID);
      setStatus(next);
    } catch {
      setStatus(null);
    } finally {
      setLoading(false);
    }
  }, [isExcluded]);

  useEffect(() => {
    refresh();
  }, [refresh, location.pathname]);

  const handleAccept = async () => {
    if (!status?.required_version) return;
    setSubmitting(true);
    setError("");
    try {
      await acceptLegalDocument(status.required_version, TERMS_DOCUMENT_ID);
      setScrollComplete(false);
      setChecked(false);
      await refresh();
    } catch (e) {
      setError(e.message || "No se pudo registrar la aceptación");
    } finally {
      setSubmitting(false);
    }
  };

  if (loading || isExcluded || !status?.acceptance_required) {
    return children;
  }

  return (
    <>
      {children}
      <div className="legal-gate-backdrop" role="presentation">
        <div className="legal-gate-modal" role="dialog" aria-modal="true">
          <h2>Actualizamos los Términos y Condiciones</h2>
          <p className="lead">
            Para seguir usando Tagnize necesitás leer y aceptar la versión vigente.
          </p>
          <TermsPanel
            readUrl={status.read_url}
            version={status.required_version}
            onScrollComplete={setScrollComplete}
          />
          <label className="terms-check-row">
            <input
              type="checkbox"
              checked={checked}
              disabled={!scrollComplete}
              onChange={(e) => setChecked(e.target.checked)}
            />
            <span>He leído y acepto los Términos y Condiciones</span>
          </label>
          {error && <p className="terms-panel-error">{error}</p>}
          <div className="legal-gate-actions">
            <button
              type="button"
              disabled={!scrollComplete || !checked || submitting}
              onClick={handleAccept}
            >
              {submitting ? "Guardando…" : "Aceptar y continuar"}
            </button>
          </div>
        </div>
      </div>
    </>
  );
}
